// extracted by mini-css-extract-plugin
export default {"colorPicker":"_1NXb____ColorPicker-module__colorPicker"};